import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Callout } from "@/shared/ui/callout";

interface AuthorizationFailureProps {
  message: string;
  onReturnToLogin: () => void;
}

export function AuthorizationFailure({ message, onReturnToLogin }: AuthorizationFailureProps) {
  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Stack spacing={3}>
        <Callout severity="error">{message}</Callout>
        <Typography variant="body2" color="text.secondary">
          You successfully signed in with your identity provider, but Situate could not authorise
          your access.
        </Typography>
        <Button variant="contained" onClick={onReturnToLogin}>
          Return to Login
        </Button>
      </Stack>
    </Container>
  );
}
